import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ISiteDto, ISiteListing } from '~/models/modules/Common/siteDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

import { SitesEnum } from '~/shared/enums/sites.enum';

@Injectable({
  providedIn: 'root'
})
export class MultiSiteService extends ApiServiceBase {

  updateAllSitesDropdownValue: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.common);
  }

  //grid-data
  getSitesGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<any[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }
  //get by id
  getSiteById(id: number) {
    return this.client.get<ISiteDto>(this._url(`/${id}`))
  }

  deleteSite(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }

  deactivateSite(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateSiteBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateSite(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  reactivateBatchSite(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }
  //get-all-sites
  getAllSites() {
    return this.client.get<ISiteListing[]>(this._url(`/get-all-sites`));
  }

  getSitesWithLicense() {
    return this.client.get<any>(this._url());
  }

  //droplist-data
  getDropdownListData() {
    return this.client.get<ISiteListing[]>(this._url(`/droplist-data`));
  }

  //create
  createSite(model: any) {
    return this.client.post<any>(this._url(), model);
  }

  //update
  updateSite(id: number, model: any) {
    return this.client.post<any>(this._url(`/${id}`), model);
  }

  ValidateSiteForDeactivation(obj: any) {
    return this.client.put<any>(this._url(`/validateBatchDeactivate`), obj);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Sites${v}`);
  }
}
